var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"load-spinner"},[_c('div',{staticClass:"custom-modal"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"info","label":"Spinning"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }